module.exports = __webpack_public_path__ + "img/SWP_Axe_2H_03.3dd55618.png";